import { useContext } from 'react';
import { Formik } from 'formik';
import { Container } from '@mui/material';
import { CircleLoader } from 'components';
import { UserForm } from './components';
import { userSchema, userContext } from './UserContext';

let Users = () => {
    let service = useContext(userContext);

    return (
        <Container>
            <Formik
                enableReinitialize={true}
                initialValues={service.user}
                validationSchema={userSchema}
                onSubmit={(values, action) => {
                    service.saveUser(values);
                    action.setSubmitting(false);
                }}
            >
                <>
                    {service.isLoading && <CircleLoader />}
                    {service.isLoading === false && <UserForm />}
                </>
            </Formik>
        </Container>
    )
}

export default Users;